import Sidemenu from '../base/sidemenu';
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { addDeviceList, addDevice } from "../../services/deviceService"
export default function UserWrite() {
  const navigate = useNavigate();
  const location = useLocation();
  const device = location.state?.device || {};
  //디바이스 기기 목록
  const [devices, setDevices] = useState([]);
  const [deviceId, setDeviceId] = useState('');
  const [users, setUsers] = useState([]);
  const [showUserPopup, setShowUserPopup] = useState(false);
  const [selectUser, setselectUser] = useState({ name: '', birth: '' });
  const [searchKeyword, setSearchKeyword] = useState("");
  //const users = ["홍길동", "김철수", "이영희", "박민수", "최가영"];

  const handleGoBack = () => {
    navigate(-1);
  };
  const token = localStorage.getItem("token");
  const getDeviceList = async () => {
    try {
      const data = await addDeviceList(token);
      if (!data.success) {
        alert(data.message);
        console.error("기기 디바이스 :", data);
        return;
      }

      console.log("기기 디바이스 목록:", data);
      setDevices(data.device_list);
      setUsers(data.user_list)
    } catch (error) {
      console.error("기기 디바이스 목록 불러오기 실패:", error);
    }
  };
  //등록 버튼
  const handleSubmit = async () => {
    try {
      // if (!deviceId || !selectUser.id) {
      //   alert("장비 ID와 사용자 정보를 선택해주세요.");
      //   return;
      // }
      console.log("등록할 장비 정보", device.id, selectUser.name, selectUser.birth)
      const res = await addDevice(token, device.id, selectUser.name, selectUser.birth);
      if (res.success) {
        console.log(res)
        alert("장비가 성공적으로 등록되었습니다.");
        navigate("/device");
      } else {
        alert(res.message);
      }
    } catch (error) {
      console.error("등록 오류:", error);
      alert(error);
    }
  };
  useEffect(() => {
    getDeviceList();
  }, []);
  return (
    <div className='flex'>
      <Sidemenu />
      <div className="device">
        <h1>장비 관리</h1>
        <div className="device_box">
          <h2 className="subpage_title"><span className="before"><span className="nametit">장비 등록</span></span></h2>
          <div className='user_writebox'>
            <div className='table02'>
              <table>
                <caption>장비 등록 표</caption>
                <colgroup>
                  <col width="20%" />
                  <col width="80%" />
                </colgroup>
                <tbody>
                  {/* <tr>
                    <th scope='row'>장비 ID</th>
                    <td>
                      <select
                        name="deviceId"
                        value={deviceId}
                        onChange={(e) => setDeviceId(e.target.value)}>
                        {devices.length === 0 ? (
                          <option>장비 없음</option>
                        ) : (
                          <>
                          <option value="" disabled>기기를 선택해주세요</option>
                            {devices.map((device) => (
                              <option key={device.id} value={device.id}>
                                {device.name || device.plug_id}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </td>
                  </tr> */}
                  <tr>
                    <th scope='row'>장비ID</th>
                    <td>{device.plug_id}</td>
                  </tr>
                  <tr>
                    <th scope='row'>사용자 이름</th>
                    <td>
                      <input
                        type="text"
                        readOnly
                        placeholder='사용자의 이름을 입력하세요.'
                        value={selectUser.name}
                        onClick={() => setShowUserPopup(true)}
                      />
                    </td>
                  </tr>
                  <tr>
                    <th scope='row'>사용자 나이</th>
                    <td> <input
                      type="date"
                      className="date"
                      value={selectUser.birth}
                      readOnly
                    /></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="btn-group">
              <button className="btncolor02" onClick={handleGoBack}>뒤로</button>
              <button className="btncolor01" onClick={handleSubmit}>확인</button>
            </div>
          </div>
        </div>
      </div>
      {showUserPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <h4>사용자 검색</h4>

            <input type="text" placeholder="사용자 이름을 입력하세요" value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} className="search-input" />

            {/* 사용자 목록 */}
            {/* <ul className="user-list">
              {users
                .filter((user) =>
                  user.name.toLowerCase().includes(searchKeyword.toLowerCase())
                )
                .map((user, idx) => (
                  <li key={user.id} onClick={() => {setselectUser(user); setShowUserPopup(false); setSearchKeyword("");}}>
                    <p><span> 이름</span>  {user.name}</p> <p><span>생년월일</span> {user.birth}</p>
                  </li>
                ))}
            </ul> */}
            <ul className="user-list">
              {users
                .filter((user) =>
                  searchKeyword
                    ? user.name.toLowerCase().includes(searchKeyword.toLowerCase())
                    : user.name === device.plug_name
                )
                .map((user) => (
                  <li
                    key={user.id}
                    onClick={() => {
                      setselectUser(user);
                      setShowUserPopup(false);
                      setSearchKeyword("");
                    }}
                  >
                    <p><span> 이름</span>  {user.name}</p> <p><span>생년월일</span> {user.birth}</p>
                  </li>
                ))}
            </ul>
            <div className="btn-group">
              <button onClick={() => setShowUserPopup(false)} className='btncolor02'>닫기</button>
            </div>
          </div>
        </div>
      )}
    </div>

  );

}
